export default "__VITE_ASSET__BfIOyxJl__"